import React from 'react'

export default function Contact() {

  return (
    <div className="contact-container">
      <p className="contact-title">Get in touch!</p>
      <p className="contact-reach-out">Please feel free to reach out to me by using any of the following!</p>

      <div className="contact-big-container">

      <a href = "mailto: jason.hk.kang@gmail.com">
      <div className="contact-email">
        <img className="contact-email-icon" alt="email" src="/images/email.png" />
        : jason.hk.kang@gmail.com
        </div>
        </a>
     
        <a href="https://www.linkedin.com/in/jason-hk-kang/" target="_blank" >
        <div className="contact-linkedin">
        <img className="contact-linkedin-icon" alt="linkedin" src="/images/linkedin2.png" />
        : linkedin.com/in/jason-hk-kang
        </div>
        </a>
      
        <a href="https://github.com/kangja" target="_blank" >
        <div className="contact-github">
            <img className="contact-github-icon" alt="github" src="/images/github2.png" /> : github.com/kangja
        </div>
        </a>
    
      </div>
      </div>
  )
}
